import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { SensorConfigurationAnalyticsRow } from 'src/api'
import { useApiInstance } from './useApiInstance'
import { buildRequestParams, ObjectType, transformPage, transformPerPage } from './helpers'

interface RequestParams {
  params?: Partial<AdminSensorConfigurationAnalyticsGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<UseQueryOptions<unknown, Error, APIList<SensorConfigurationAnalyticsRow>>, 'queryKey' | 'queryFn'>;
}

interface AdminSensorConfigurationAnalyticsGetParams {
  limit: number;
  offset: number;
  sort: string;
  configType: 'default' | 'default_not_matches' | 'custom' | 'unknown';
  search: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
  configType: 'string',
  search: 'string',
}

export const useSensorConfigurationAnalyticsListRequest = ({ params = {}, paramsTransform = [], options }: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [transformPerPage, transformPage, ...paramsTransform].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<AdminSensorConfigurationAnalyticsGetParams>(transformedParams, schema)

  return useQuery<unknown, Error, APIList<SensorConfigurationAnalyticsRow>>(
    [Entities.SensorConfigurationAnalytics, JSON.stringify(transformedParams)],
    async () => {
      const { limit, offset, sort, configType, search } = queryParams
      const { data } = await api.v1AdminSensorsConfigurationAnalyticsGet(limit, offset, sort, configType, search)
      return data
    },
    options
  )
}
